// file generated by "pnpm create-light-plus-ext"
import { Tag } from '@lezer/highlight';

export const LIGHT_PLUS_COLOR_TO_TAG: { [color: string]: string } = {
  '#0000': 'color_0000',
  '#000000': 'color_000000',
  '#000000FF': 'color_000000FF',
  '#000080': 'color_000080',
  '#0000FF': 'color_0000FF',
  '#001080': 'color_001080',
  '#0070C1': 'color_0070C1',
  '#007ACC': 'color_007ACC',
  '#008000': 'color_008000',
  '#0451A5': 'color_0451A5',
  '#098658': 'color_098658',
  '#16825D': 'color_16825D',
  '#267F99': 'color_267F99',
  '#369432': 'color_369432',
  '#61616130': 'color_61616130',
  '#6F6F6F': 'color_6F6F6F',
  '#767676': 'color_767676',
  '#795E26': 'color_795E26',
  '#800000': 'color_800000',
  '#811F3F': 'color_811F3F',
  '#939393': 'color_939393',
  '#ADD6FF80': 'color_ADD6FF80',
  '#AF00DB': 'color_AF00DB',
  '#CECECE': 'color_CECECE',
  '#D3D3D3': 'color_D3D3D3',
  '#E5EBF1': 'color_E5EBF1',
  '#E8E8E8': 'color_E8E8E8',
  '#EE0000': 'color_EE0000',
  '#F3F3F3': 'color_F3F3F3',
  '#FFF': 'color_FFF',
  '#FFFFFF': 'color_FFFFFF',
  '#A31515': 'color_A31515',
  '#C72E0F': 'color_C72E0F',
  '#C8DDF150': 'color_C8DDF150',
  '#CD3131': 'color_CD3131',
  '#D16969': 'color_D16969',
  '#FF0000': 'color_FF0000'
};

export const LIGHT_PLUS_CUSTOM_TAGS = {
  color_0000: Tag.define(),
  color_000000: Tag.define(),
  color_000000FF: Tag.define(),
  color_000080: Tag.define(),
  color_0000FF: Tag.define(),
  color_001080: Tag.define(),
  color_0070C1: Tag.define(),
  color_007ACC: Tag.define(),
  color_008000: Tag.define(),
  color_0451A5: Tag.define(),
  color_098658: Tag.define(),
  color_16825D: Tag.define(),
  color_267F99: Tag.define(),
  color_369432: Tag.define(),
  color_61616130: Tag.define(),
  color_6F6F6F: Tag.define(),
  color_767676: Tag.define(),
  color_795E26: Tag.define(),
  color_800000: Tag.define(),
  color_811F3F: Tag.define(),
  color_939393: Tag.define(),
  color_ADD6FF80: Tag.define(),
  color_AF00DB: Tag.define(),
  color_CECECE: Tag.define(),
  color_D3D3D3: Tag.define(),
  color_E5EBF1: Tag.define(),
  color_E8E8E8: Tag.define(),
  color_EE0000: Tag.define(),
  color_F3F3F3: Tag.define(),
  color_FFF: Tag.define(),
  color_FFFFFF: Tag.define(),
  color_A31515: Tag.define(),
  color_C72E0F: Tag.define(),
  color_C8DDF150: Tag.define(),
  color_CD3131: Tag.define(),
  color_D16969: Tag.define(),
  color_FF0000: Tag.define()
};

let ct = LIGHT_PLUS_CUSTOM_TAGS;

export const LIGHT_PLUS_STYLES = [
  { tag: ct.color_0000, color: '#0000' },
  { tag: ct.color_000000, color: '#000000' },
  { tag: ct.color_000000FF, color: '#000000FF' },
  { tag: ct.color_000080, color: '#000080' },
  { tag: ct.color_0000FF, color: '#0000FF' },
  { tag: ct.color_001080, color: '#001080' },
  { tag: ct.color_0070C1, color: '#0070C1' },
  { tag: ct.color_007ACC, color: '#007ACC' },
  { tag: ct.color_008000, color: '#008000' },
  { tag: ct.color_0451A5, color: '#0451A5' },
  { tag: ct.color_098658, color: '#098658' },
  { tag: ct.color_16825D, color: '#16825D' },
  { tag: ct.color_267F99, color: '#267F99' },
  { tag: ct.color_369432, color: '#369432' },
  { tag: ct.color_61616130, color: '#61616130' },
  { tag: ct.color_6F6F6F, color: '#6F6F6F' },
  { tag: ct.color_767676, color: '#767676' },
  { tag: ct.color_795E26, color: '#795E26' },
  { tag: ct.color_800000, color: '#800000' },
  { tag: ct.color_811F3F, color: '#811F3F' },
  { tag: ct.color_939393, color: '#939393' },
  { tag: ct.color_ADD6FF80, color: '#ADD6FF80' },
  { tag: ct.color_AF00DB, color: '#AF00DB' },
  { tag: ct.color_CECECE, color: '#CECECE' },
  { tag: ct.color_D3D3D3, color: '#D3D3D3' },
  { tag: ct.color_E5EBF1, color: '#E5EBF1' },
  { tag: ct.color_E8E8E8, color: '#E8E8E8' },
  { tag: ct.color_EE0000, color: '#EE0000' },
  { tag: ct.color_F3F3F3, color: '#F3F3F3' },
  { tag: ct.color_FFF, color: '#FFF' },
  { tag: ct.color_FFFFFF, color: '#FFFFFF' },
  { tag: ct.color_A31515, color: '#A31515' },
  { tag: ct.color_C72E0F, color: '#C72E0F' },
  { tag: ct.color_C8DDF150, color: '#C8DDF150' },
  { tag: ct.color_CD3131, color: '#CD3131' },
  { tag: ct.color_D16969, color: '#D16969' },
  { tag: ct.color_FF0000, color: '#FF0000' }
];
